import "./navigation";
import "./bacteria";
import "./healthy";
import "./help";
import throttle from "lodash/throttle";
import {isVisible} from "./functions";

$(() => {

    const $window = $(window);
    const $body = $("body");
    const $language = $("#language", $body);
    const $main = $("main", $body);

    $(".carousel", $main).carousel();

    // Languages switch (<select>)
    $language.change(() => location = $language.val());

    setReveal();

    function setReveal() {

        function doReveal() {
            $("main .load-reveal", $body).toArray().forEach(el => {
                if (isVisible(el)) {
                    el.classList.add("is-revealed");
                }
                else {
                    el.classList.remove("is-revealed");
                }
            })
        }

        setTimeout(doReveal, 400); // set delay for smooth transition after jQuery
                                   // ready
        $window.on("scroll resize", throttle(doReveal, 500)); // set throttle to
                                                              // decrease CPU
                                                              // issues
    }
});


// WEBPACK FOOTER //
// ./js/main.js